<script>
import guanggao from '../assets/guangaotiao.png';
import { GetQuestionnaire } from "../api/user";
import { log } from 'three';
export default {
  data() {
    return{
      drawer:false,
      selectedValue: '',
      range: Array.from({ length: 11 }, (_, i) => i),
      options: ['容易上手','性能稳定','售后服务响应快','帮助指引完善','界面美观','文档说明清晰','界面清晰易理解','安全性高','功能完善','能高效完成任务','优惠活动多','价格优惠'],
      checkboxGroup: [],
      textarea:'',
      text:''
    }
  },
  props: {
    name: {
      type: String,
      required: false
    },
    isShowHelp: {
      type: Boolean
    }
  },
  computed: {
    shouldShowReasons() {
      if(this.selectedValue == ''){
        return true
      }
      return ![0, 1, 2, 3, 4, 5].includes(Number(this.selectedValue));
    }
  },
  methods:{
    submit(){
      this.getquestion()
    },
    async getquestion(){
      let data = await GetQuestionnaire()
      if(data.code == 200){
        this.$message.success('提交成功，感谢您的反馈')
      }else{
        this.$message.error('服务器异常请稍后重试')
      }
      this.drawer = false
    },
    goorder(){
      this.$router.push({
        path: "/order", 
      });
    },
    
  }
}
</script>

<template>
  <div class="gobal_guanggao">
    <div class="flex1" :style="{ height: `50px`, 'margin-left': '20px' }">
      <div style="border: 1px solid #bfc9ff;width: 80px;color:#3d4366;font-size: 12px;padding: 2px;text-align: center;background: linear-gradient(79deg,#e7ebff 5.01%,#dce1fb 33.86%,#eff1ff 68.01%,#dce1fb 90.37%)">
        <i class="el-icon-star-on"></i>热门新品
      </div>
      <span style="font-weight: 900;font-size: 13px;margin-left: 20px;cursor: pointer" class="i913900k" @click="goorder">
        新款高性能服务器上线，稳定运维7×24小时！<span class="chakan">查看详情 ></span>
      </span>
    </div>
    <div v-show="name" style="font-weight: 900;height: 50px;background: white;line-height: 50px;padding-left: 30px;border-bottom: 1px solid #e6e9ef;position: relative;">
      {{ name }}

      <div style="display: inline-block;float: right" class="productTY" v-show="!isShowHelp">
        <span @click="drawer = !drawer" style="cursor:pointer;margin-right: 10px;background: linear-gradient(90deg,#559eff,#3082ff);height: 24px;font-size: 12px;color: white;border-radius: 10px;padding: 5px 15px 5px 15px;"><i class="el-icon-star-on moving-star"></i>产品体验，您说了算</span>
        <el-popover
            placement="bottom"
            trigger="hover">
          <div class="saomao">
            <img src="@/assets/yxtidcerweima.png" width="180">
            <p>微信扫一扫，关注公众号</p>
            <p>小程序管理服务器，获取优惠资讯</p>
          </div>
          <span slot="reference" style="cursor:pointer;margin-right: 20px;height: 24px;font-size: 12px;color: black;border-radius: 10px;padding: 5px 15px 5px 15px;border:0.5px solid black"><i class="el-icon-full-screen"></i>限时领福利</span>
        </el-popover>

        <span style="cursor:pointer;color: rgba(0,0,0,0.9);float: right;margin-right: 40px;font-weight: 400;font-size: 12px">查看帮助文档<i style="margin-left: 5px" class="el-icon-link"></i></span>
      </div>
    </div>
    <el-drawer
        :visible.sync="drawer"
        :with-header="false"
        :size="550"
    >

      <div>
        <div style="border-bottom: 1px solid #ddd;height: 50px">
          <span @click="drawer =false" style="cursor:pointer;float: right;font-weight: 900;margin-right: 10px;font-size: 20px;line-height: 50px"><i class="el-icon-close"></i></span>
        </div>

        <div style="font-weight: 900;font-size: 22px;padding: 30px;margin: auto">
          <div style="margin-bottom: 30px;position: relative">
            <span style="position: absolute;top:40px;left: 20px;color: white;font-size: 20px">亿信通产品体验调查</span>
            <img src="@/assets/guangaotuijian.png" width="480px">
          </div>
          <p>
            您是否愿意<br>
            向您的同事或朋友推荐使用亿信通{{name}}？
          </p>
          <p style="color: gray;font-size: 14px;font-weight: 400;margin-top: 15px;">
            希望您能与我们分享真实的产品使用感受。
          </p>

          <div style="margin-top: 50px">
            <el-radio-group v-model="selectedValue">
              <el-radio-button
                  v-for="num in range"
                  :key="num"
                  :label="num.toString()"
                  class="radio1"
              >
                {{ num }}
              </el-radio-button>
            </el-radio-group>

            <div style="margin-top: 10px;font-size: 13px;color: gray;font-weight: 0">
              <span>(极不愿意)</span>
              <span style="float: right;margin-right: 10px">(非常愿意)</span>
            </div>
          </div>

          <div v-show="shouldShowReasons">
            <p style="margin-top: 50px;font-weight: 900;font-size: 22px">推荐的原因</p>
            <el-checkbox-group v-model="checkboxGroup" style="font-size:12px;padding: 5px">
              <el-checkbox-button v-for="data in options" :label="data" :key="data">{{data}}</el-checkbox-button>
            </el-checkbox-group>
           </div>

          <div class="otherR">
            <span style="font-size: 12px;color: #888">其他原因</span>
            <el-input v-model="text" placeholder="请输入其他原因，使用空格区分不同原因"  style="font-size: 12px;margin-top: 10px;display:inline-block;width: 380px;margin-left: 15px"></el-input>

          </div>


          <div style="margin-top: 80px">
            <div style="font-size: 14px;font-weight: 900">更多反馈<span style="font-size: 12px;margin-left: 5px;color:#ddd">(选填)</span></div>
            <el-input
                style="font-size: 12px;margin-top: 10px;"
                type="textarea"
                placeholder="感谢反馈，期待您分享更多使用感受与建议，让我们为您提供更好的服务"
                v-model="textarea"
                maxlength="200"
                show-word-limit
            >
            </el-input>
            <div style="margin-top: 20px" class="submit_button">
              <el-button type="primary" @click="submit" :disabled="!selectedValue">提交反馈</el-button>
              <el-button @click="drawer=false">取消</el-button>
            </div>
          </div>

        </div>
      </div>


    </el-drawer>
  </div>
</template>

<style scoped>
.otherR ::v-deep .el-input__inner {
  height: 30px;
  border-radius: 0px;
}
.submit_button ::v-deep .el-button {
  padding: 10px 15px 10px 15px !important;
}

::v-deep .el-textarea__inner{
  min-height: 160px !important;
}
::v-deep .el-checkbox-button__inner{
  border: 0 !important;
  border-radius: 0 !important;
  font-size: 12px !important;

}

::v-deep .el-checkbox-button:first-child .el-checkbox-button__inner{
  border-radius: 0 !important;
  border:0px !important
}
::v-deep .el-checkbox-button {
  margin-right: 5px;
  margin-top: 10px;
  border-radius: 0px !important;
  border: 1px solid #ddd;
}

.flex1 {
  display: flex;
  align-items: center; /* 垂直居中 */
}

.moving-star {
  font-size: 15px;
  animation: bounce 1s infinite; /* 添加动画 */
}

@keyframes bounce {
  0%, 20%, 50%, 80%, 100% {
    transform: translateY(0);
  }
  40% {
    transform: translateY(-10px);
  }
  60% {
    transform: translateY(-5px);
  }
}

.saomao{
  font-weight: 400;
  font-size: 12px;
  text-align: center;
  color: black;
}

.radio1 {
  margin-right: 7px;
  width: 35px; /* 设置宽度 */
  height: 35px; /* 设置高度 */
}
::v-deep .radio1  .el-radio-button__inner{
  border-radius: 50% !important;
  font-size: 16px;
  line-height: 35px;
  color: black;
  border: 0px;
  background: #EEEEEE !important;
  padding: 0px !important;
  font-weight: 900 !important;
  width: 35px; 
  height: 35px;
}
::v-deep .el-radio-button__inner{
  background-color: #409EFF !important;
}
::v-deep .el-radio-button__orig-radio:checked+.el-radio-button__inner {
    color: #fff;
    background: #409EFF !important;
}
@media (max-width: 768px) {
 .productTY{
  display: none !important;
 }
 .i913900k{
  font-size: 12px !important;
  margin-left: 0px !important;
 }
 .chakan{
  display: none;
 }
}
</style>
